
class CkeditorClassicComponent extends HTMLElement {
    editor;
    container;

    constructor() {
        super();
    }

    static get observedAttributes() {
        return ['staticform'];
    }

    removeJSScript(filename) {
        var tags = document.getElementsByTagName('script');
        for (var i = tags.length; i >= 0; i--) { //search backwards within nodelist for matching elements to remove
            if (tags[i] && tags[i].getAttribute('src') != null && tags[i].getAttribute('src') == filename)
                tags[i].parentNode.removeChild(tags[i]); //remove element by calling parentNode.removeChild()
        }
    }


    isScriptLoaded(url) {
        var scripts = document.getElementsByTagName('script');
        for (var i = scripts.length; i--;) {
            if (scripts[i].src == url) return true;
        }
        return false;
    }

    attributeChangedCallback(attributeName, oldValue, newValue) {
        // Codice da eseguire quando un attributo del componente viene modificato
        console.log("attributeChangedCallback : ", this.getAttribute("staticform"));
        const scriptClassic = document.createElement("script");
        scriptClassic.src = "https://cdn.jsdelivr.net/npm/ckeditor5-classic-plus@36.0.1/build/ckeditor.min.js";
        const scriptInline = document.createElement("script");
        scriptInline.src = "https://cdn.jsdelivr.net/npm/costumized-ckeditor-inline@1.0.2/build/ckeditor.min.js";
        scriptClassic.defer = true;
        scriptInline.defer = true;
        scriptClassic.onload = () => {
            // La libreria è stata caricata correttamente, puoi utilizzarla qui
            // Esegui il codice che dipende dalla libreria esterna
            // ... altri codici che utilizzano la libreria esterna ...
        };
    }

    connectedCallback() {
        this.render();
    }



    render() {
        const btnContainer = document.createElement("div");
        const buttonContainerReadOnly = document.createElement("div");
        const buttonsContainer = document.createElement("div");
        buttonsContainer.classList.add("d-flex", "justify-content-evenly");
        buttonContainerReadOnly.classList.add("btn", "btn-group", "btn-group-sm", "mb-4");

        // button zoom+
        const buttonReadOnly = document.createElement("button");
        buttonReadOnly.classList.add(
            "btn",
            "btn-soft-primary",
            "waves-effect",
            "waves-light",
            "px-4",
            "readOnlyBtn"
        );
        buttonReadOnly.onclick = () => {
            this.toggleReadOnly();
            console.log("dispaccio il click");

            buttonReadOnly.dispatchEvent(new CustomEvent("readOnlyClick", {
                bubbles: true,
                detail: {
                    readOnly: this.editor.isReadOnly,
                    data: this.editor.getData()
                }
            }));
        };
        // icona zoom+
        const readOnlyIcon = document.createElement("i");
        readOnlyIcon.classList.add("uil", "uil-search-plus");
        buttonReadOnly.appendChild(readOnlyIcon);
        // span (text)
        const readOnlyText = document.createElement("span");
        readOnlyText.classList.add("mx-2");
        readOnlyText.innerText = "Toggle readOnly";
        buttonReadOnly.appendChild(readOnlyText);
        buttonContainerReadOnly.appendChild(buttonReadOnly);
        buttonsContainer.appendChild(buttonContainerReadOnly);
        btnContainer.appendChild(buttonsContainer);
        const container = document.createElement("div");
        container.setAttribute("id", "editor");
        



        // this.appendChild(btnContainer);
        this.appendChild(container);

        ClassicEditor
            .create(document.querySelector('#editor'),
                {
                    language: 'it',
                    clipboard_defaultContentType: 'text',

                    fontFamily: {
                        options: [
                            'default',
                            'Times New Roman, sans-serif',
                            'Helvetica',
                            'Roboto'
                        ]
                    },

                    // toolbar: [
                    //     'heading', '|', 'bulletedList', 'numberedList', 'alignment', 'undo', 'redo'
                    // ]
                }
            )
            .then(editor => {
                console.log("editor:", editor);
                this.editor = editor;
                const self = this;
                this.addEventListener("getFormDataSave", function () {
                    console.log("dispaccio evento send data");
                    this.dispatchEvent(new CustomEvent("sendFormDataSave", {
                        bubbles: true,
                        detail: {
                            readOnly: this.editor.isReadOnly,
                            data: this.editor.getData()
                        }
                    }));
                });

                this.addEventListener("setFormDataEdit", (event) => {
                    console.log("ricevo dati da settare in editor", event);
                    this.editor.setData(event.detail.data);
                    // this.editor.enableReadOnlyMode("editor");
                });


                this.addEventListener("getFormDataCreate", function () {
                    console.log("dispaccio evento send data");
                    this.dispatchEvent(new CustomEvent("sendFormDataCreate", {
                        bubbles: true,
                        detail: {
                            readOnly: this.editor.isReadOnly,
                            data: this.editor.getData()
                        }
                    }));
                });
                const doc = this.editor.editing.view.document;
                /* doc.on("clipboardInput", async (event,data) => {
                    await self.filterClipboard(event, data);
                }); */
                doc.on("paste", async (event,data) => {
                    await self.filterClipboard(event, data);
                    return false;
                });

                
                this.dispatchEvent(new CustomEvent("editorReady", {
                    bubbles: true,
                    detail: {
                        self: this
                    }
                }));
            })
            .catch(error => {
                console.error(error);
            });

    }

    escapeHtml(html) {
        const map = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;'
        };
        return html.replace(/[&<>"']/g, char => map[char]);
    }
    cleanText(text){
        const regex = /(\r\n|\n)/g;
        return this.escapeHtml(text).replace(regex, "<br/>");
    }
    async filterClipboard(event ,data) {
        const saveData = this.editor.getData();
        const saveCursorPosition = this.editor.model.document.selection.getFirstPosition();
        const e = data.domEvent;
        let value = "<p>"+this.cleanText(await e.clipboardData.getData('text/plain'))+"</p>";


        this.editor.setData(`${saveData}`);
        console.log("filterClipboard",event.name, value, event, data);
        const self = this;
        this.editor.model.change( writer => {
            writer.setSelection(saveCursorPosition);
            const viewFragment = this.editor.data.processor.toView( value );
            const modelFragment = this.editor.data.toModel( viewFragment );
            this.editor.model.insertContent( modelFragment, this.editor.model.document.selection);
        } );
    }

    toggleReadOnly() {
        console.log("editor", this.editor);
        console.log("readOnly", this.editor.isReadOnly);
        if (this.editor.isReadOnly) {
            this.editor.disableReadOnlyMode("editor");
        } else {
            this.editor.enableReadOnlyMode("editor");
        }
    }


    disconnectedCallback() {
        // Codice da eseguire quando il componente viene rimosso dal DOM
    }


}


customElements.define("ck-editor-classic", CkeditorClassicComponent);
